import React from "react";
import Helmet from "react-helmet";
import { graphql, Link } from "gatsby";

import "../styles";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

export const Title = ({ children }) => <h2 className="title">{children}</h2>;

const TemplateWrapper = ({
  footerData = null,
  centered = true,
  navbarData = null,
  title,
  sidebar,
  children
}) => {
  const heading = title ? <Title>{title}</Title> : null;
  return (
    <div>
      <Helmet>
        <html lang="si" />
        <meta
          name="keywords"
          content="Osnovna šola, vrtec, otroci, Ivan Rob, šola, pouk, aktivnosti"
        />
      </Helmet>
      <Navbar data={navbarData} />
      <main>
        {centered ? (
          <Container sidebar={sidebar}>
            {heading}
            {children}
          </Container>
        ) : (
          <>
            {heading}
            {children}
          </>
        )}
      </main>
      <Footer data={footerData} />
    </div>
  );
};

export const Container = ({ children, sidebar }) => (
  <div className={`container ${sidebar ? "withSidebar" : ""}`}>
    {sidebar ? (
      <>
        <aside>
          {sidebar.map((item, idx) => (
            <Link key={idx} activeClassName="active" to={item.to}>
              {item.label}
            </Link>
          ))}
        </aside>
        <div className="content">{children}</div>
      </>
    ) : (
      children
    )}
  </div>
);

export const TwoColumn = ({ children, className }) => (
  <div className={`twoColumn ${className || ""}`}>{children}</div>
);

export const query = graphql`
  fragment LayoutFragment on Query {
    footerData: allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "footer" } } }
    ) {
      edges {
        node {
          id
          frontmatter {
            logoImage {
              image
              imageAlt
              tagline
            }
            socialLinks {
              image
              imageAlt
              label
              linkURL
            }
          }
        }
      }
    }
    navbarData: allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "navbar" } } }
    ) {
      edges {
        node {
          id
          frontmatter {
            logoImage {
              image
              imageAlt
            }
            menuItems {
              label
              linkType
              linkURL
            }
          }
        }
      }
    }
  }
`;

export default TemplateWrapper;
